const useNewDomain = process.env.REACT_APP_USE_NEW_DOMAIN === 'true';

export const DOMAIN = useNewDomain ? 'bambus.at' : 'bambus.io';
export const CONTACT_EMAIL = `beratung@${DOMAIN}`;
export const WEBSITE_URL = `https://www.${DOMAIN}`;
export const PRIVACY_URL = `${WEBSITE_URL}/datenschutz/`;
export const IMPRINT_URL = `${WEBSITE_URL}/impressum/`;
export const LANDING_URL = `https://${DOMAIN}`;

export const getSubdomainUrl = (subdomain: string): string =>
  `https://${subdomain}.${DOMAIN}`;
